import * as yup from "yup";

export const editAgentSchema = yup.object({
  name: yup.string().required("Full Name is required"),
  email: yup.string().email("Invalid email address").required("Email is required"),
  role_description: yup.string().required("Role description is required").max(255, "Maximum 255 characters"),
});
